export default __webpack_public_path__ + "static/media/AFTSLogo-footer.a7aaa4b5.png";